var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nearuser"},[(_vm.near[0])?_c('div',[_c('router-link',{attrs:{"to":{ path: '/station/' + _vm.near[0].id }}},[_vm._v(" Your Nearest Station: "),_c('strong',[_vm._v(_vm._s(_vm.near[0].station.site_name))])])],1):_c('div',[_vm._v("No nearby stations found :(")])])
}
var staticRenderFns = []

export { render, staticRenderFns }